import { DANI } from "@/lib/constants";

export default function PrintPlan({ weekPlan }) {
  const days = DANI.filter((d) => weekPlan[d.id].length > 0);

  return (
    <div id="print-plan">
      <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>Tjedni plan organiziranog slobodnog vremena</h1>
      <p style={{ color: "#475569", marginBottom: 4 }}>Produženi boravak · 2 školska sata dnevno (120 min)</p>
      <p style={{ color: "#475569", marginBottom: 24 }}>Tjedan: ______________ Razred: ______________ Učitelj/ica: ______________</p>

      {days.map((d) => {
        const plan = weekPlan[d.id];
        const totalMin = plan.reduce((s, p) => s + p.trajanje, 0);
        const materijali = [...new Set(plan.flatMap((p) => p.materijali))];
        let cursor = 0;
        return (
          <div key={d.id} style={{ marginBottom: 28, breakInside: "avoid-page" }}>
            <h2 style={{ fontSize: 19, fontWeight: 800, color: "#4338ca", borderBottom: "2px solid #4338ca", paddingBottom: 4, marginBottom: 10 }}>
              {d.label} — {totalMin} min · {plan.length} {plan.length === 1 ? "aktivnost" : "aktivnosti"}
            </h2>
            {materijali.length > 0 && (
              <div style={{ marginBottom: 12, padding: 10, border: "1px solid #cbd5e1", borderRadius: 8, fontSize: 12 }}>
                <strong>Pripremiti materijale:</strong> {materijali.join(", ")}
              </div>
            )}
            {plan.map((p, i) => {
              const start = cursor;
              cursor += p.trajanje;
              return (
                <div key={p.planId} style={{ marginBottom: 14, breakInside: "avoid" }}>
                  <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 2 }}>
                    {i + 1}. {p.naziv} <span style={{ fontWeight: 400, color: "#64748b" }}>({start}.–{cursor}. min · {p.mjesto} · {p.razina_buke.toLowerCase()})</span>
                  </h3>
                  <p style={{ fontSize: 13, color: "#334155", margin: "3px 0" }}>{p.opis}</p>
                  {p.materijali.length > 0 && (
                    <p style={{ fontSize: 12, color: "#64748b", margin: "2px 0" }}>Materijali: {p.materijali.join(", ")}</p>
                  )}
                  <ol style={{ fontSize: 13, color: "#334155", paddingLeft: 20, margin: "3px 0" }}>
                    {p.koraci.map((k, j) => (
                      <li key={j} style={{ marginBottom: 2 }}>{k}</li>
                    ))}
                  </ol>
                  <p style={{ fontSize: 12, color: "#64748b", margin: "2px 0" }}>Cilj: {p.cilj}</p>
                </div>
              );
            })}
          </div>
        );
      })}

      <p style={{ marginTop: 24, fontSize: 11, color: "#94a3b8" }}>Izrađeno u aplikaciji Boravko — riznica ideja za produženi boravak</p>
    </div>
  );
}
